<template>
  <div class="container-fluid bg-light">
    <!-- REG HORIZON -->
    <div class="row text-white bg-kpmg-blue py-4 mb-4">
      <div class="col">
        <h1 class="kstyle">Settings</h1>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-container>
          <b-row class="bg-white pb-4" v-if="key">
            <b-col>
              <h5 class="kpmg">Your current data subscription</h5>
              <span>
                <div>key: {{account.key}}</div>
                <div>organisation: {{account.organisation}}</div>
                <div>comments: {{account.comments}}</div>
                <div>review date: {{account.expiry}}</div>
                <div><b-link :to="{ name: 'Regulators' }">Sources: {{ publishers.length }}</b-link></div>
                <div v-if="account.acgroups.find(x => x === 'cpdvisitor')"><b-link :to="{ name: 'ImpactPolicies' }">Climate Policy Dashboard: Yes</b-link></div>
                <div v-else>Climate Policy Dashboard: No</div>
                <div v-if="account.acgroups.find(x => x === 'initiativesvisitor')"><b-link :to="{ name: 'ImpactInitiatives' }">Initiatives (e.g. ESG Tax): Yes</b-link></div>
                <div v-else>Initiatives (ESG Tax): No</div>
                <div v-if="account.acgroups.find(x => x === 'insightsvisitor')"><b-link :to="{ name: 'Articles' }">Insights: Yes</b-link></div>
                <div v-else>Insights: No</div>
              </span>
            </b-col>
          </b-row>
          <b-row class="bg-white pb-4" v-if="!loggedIn">
            <b-col>
              <h5 class="kpmg">Login</h5>
              <div class="mb-4">
                <b-form-input v-model="keyForm" :type="inputType" placeholder="Enter your passkey" id="login"></b-form-input>
              </div>
              <div v-if="keyForm" class="mb-4">
                <b-button variant="outline-primary" class="mr-4" @mousedown="inputType = 'input'" @mouseup="inputType = 'password'" id="go">Show passkey</b-button>
                <b-button variant="outline-primary" @click="login" id="go">Sign in</b-button>
              </div>
              <div v-if="legalterms" class="mb-4">
                <b-button variant="outline-primary" @click="save" id="go">Update</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="bg-white pb-4" v-if="showTerms">
            <b-col>
              <h5 class="kpmg">Accept terms and conditions</h5>
              <div class="mb-4">
                <div class="mb-2" style="height: 50vh; overflow-y: scroll;">
                  <div v-if="!account.demo">
                    <legal-simple></legal-simple>
                  </div>
                  <div v-if="account.demo">
                    <legal-agreement :account="account"></legal-agreement>
                  </div>
                </div>
                <div class="my-4">
                  <b-button variant="outline-primary" class="mr-4" @click="agreeTerms" id="go">Accept</b-button>
                  <b-button variant="outline-primary" @click="remove" id="go">Reject</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="bg-white pb-4" v-if="showLogout" >
            <b-col>
              <span>
              <div>
                <b-button variant="outline-primary" @click="remove">Sign out</b-button>
              </div>
              </span>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LegalAgreement from '@/components/LegalAgreement.vue'
import LegalSimple from '@/components/LegalSimple.vue'

export default {
  name: 'Settings',
  components: {
    LegalAgreement,
    LegalSimple
  },
  computed: {
    showLogout: function () {
      return this.loggedIn && this.key
    },
    showTerms: function () {
      return this.loggedIn && !this.key
    },
    key: {
      get () {
        return this.$store.state.key
      },
      set (payload) {
        this.$store.commit('setKey', payload)
      }
    },
    publishers: function () {
      let publishers = this.account.publishers
      publishers.sort()
      return publishers
    }
  },
  created: async function () {
    const key = window.localStorage.getItem('frmCloudExApiKey')
    if (!key) {
      return
    } else {
      this.$store.commit('setKey', key)
    }
    try {
      let apiName = 'cosmos'
      let path = `/account`
      let response = await this.$Amplify.API.get(apiName, path)
      this.account = response
      this.loggedIn = true
    } catch (e) {
      this.$logger.warn('getCategories loading error' + e)
    }
  },
  data () {
    return {
      account: false,
      inputType: 'password',
      keyForm: null,
      legalterms: false,
      loggedIn: false
    }
  },
  methods: {
    agreeTerms: async function () {
      window.localStorage.setItem('frmCloudExApiKey', this.keyForm)
      try {
        const apiName = 'cosmos'
        const path = `/account`
        const response = await this.$Amplify.API.get(apiName, path)
        this.account = response
        if (this.account.key === this.keyForm) {
          window.localStorage.setItem('frmCloudExUsername', this.account.organisation)
          if (!this.account.acgroups) {
            this.account.acgroups = ['norole']
          }
          window.localStorage.setItem('frmCloudExApiKey', this.keyForm)
          window.localStorage.setItem('frmCloudExAcgroups', JSON.stringify(this.account.acgroups))
          window.localStorage.setItem('frmCloudExUsername', this.account.organisation)
          const user = { acgroups: this.account.acgroups }
          this.$store.commit('setKey', this.keyForm)
          this.$store.commit('setUsername', this.account.organisation)
          this.$store.commit('setUser', user)
          this.$stat.log({ page: 'settings', action: 'logged in' })
          if (this.account.homepage) {
            this.$router.replace({ name: this.account.homepage })
          } else {
            this.$router.replace({ name: 'Start' })
          }
        }
      } catch (e) {
        this.$logger.warn('getCategories loading error' + e)
      }
    },
    login: async function () {
      // window.localStorage.setItem('frmCloudExApiKey', this.keyForm)
      try {
        const init = {
          headers: {
            'X-API-KEY': this.keyForm
          }
        }
        let response = await this.$Amplify.API.get('cosmos', '/account', init)
        if (response.key === this.keyForm) {
          this.account = response
          this.loggedIn = true
        }
      } catch (e) {
        this.$logger.warn('getCategories loading error' + e)
      }
    },
    remove: function () {
      this.$stat.log({ page: 'settings', action: 'logged out' })
      window.localStorage.removeItem('frmCloudExApiKey')
      window.localStorage.removeItem('frmCloudExUsername')
      this.account = false
      this.$store.commit('setKey', null)
      this.$store.commit('setUsername', null)
      this.loggedIn = false
    },
    save: async function () {
      window.localStorage.setItem('frmCloudExApiKey', this.keyForm)
      try {
        const apiName = 'cosmos'
        const path = `/account`
        const response = await this.$Amplify.API.get(apiName, path)
        this.account = response
        if (this.account.key === this.keyForm) {
          window.localStorage.setItem('frmCloudExUsername', this.account.organisation)
          if (!this.account.acgroups) {
            this.account.acgroups = ['norole']
          }
          window.localStorage.setItem('frmCloudExAcgroups', JSON.stringify(this.account.acgroups))
          window.localStorage.setItem('frmCloudExUsername', this.account.organisation)
          const user = { acgroups: this.account.acgroups }
          this.$store.commit('setKey', this.keyForm)
          this.$store.commit('setUsername', this.account.organisation)
          this.$store.commit('setUser', user)
          this.$stat.log({ page: 'settings', action: 'logged in' })
        }
      } catch (e) {
        this.$logger.warn('getCategories loading error' + e)
      }
    }
  }
}
</script>
